<template>
  <file-upload
    :data.sync="value"
    :needValid="true"
    @fileValid="fileValid"
    :fileSize="config.rules.fileConfig.size"
    :fileType="config.rules.fileConfig.type"
    :limit="config.rules.fileConfig.limit"
    :disable="disable"
  ></file-upload>
</template>
<script>
export default {
  props: ["data", "config", "disable"],
  data() {
    return {};
  },
  computed: {
    value: {
      get() {
        return this.data;
      },
      set(val) {
        this.$emit("update:data", val);
      },
    },
  },
  methods: {
    fileValid() {
      this.$emit("fileValid", this.config.enName);
    },
  },
};
</script>
